<script setup>
import {onMounted, ref, watch} from "vue";
import {usePiniaStore} from "../store/pinia_store";
import _, {isEmpty} from "lodash";

const props = defineProps({
    brandId: {
        type: String,
        required: true,
    },
    products: {
        type: Object,
        required: true,
    },
    skus: {
        type: Array,
        required: true,
    },
    dentaidApiInstance: {
        type: Function,
        required: true,
    },
    cartEventBus: {
        type: Object,
        required: true,
    },
    eventBus: {
        type: Object,
        required: true,
    }
})

const piniaStore = usePiniaStore();

const language = ref(window.drupalSettings.ef2_custom.language ?? 'nl');

const loaded = ref(false);
const prices = ref(null);

const getPrices = async function () {
    if (isEmpty(drupalSettings.ef2_custom.customer_number)) {
        loaded.value = true;

        return;
    }

    if (piniaStore.isLoading) {
        return;
    }


    return await props.dentaidApiInstance.post(`prices?token=${piniaStore.parsedToken}`, {
        items: _.map(props.skus, function (sku) {
            return {
                sku: sku,
            }
        })
    })
        .then(response => {
            prices.value = response.data;
            loaded.value = true;
        });
}

onMounted(() => {
    getPrices();
})

watch(() => piniaStore.isLoading, async () => await getPrices());

</script>

<template>
    <div class="view-content row">
        <dentaid-product-teaser v-for="product in products"
                                v-if="loaded"
                                :key="product.sku"
                                :crm-id="product.sku"
                                :dentaid-api-instance="dentaidApiInstance"
                                :product="product"
                                :cart-event-bus="cartEventBus"
                                :event-bus="eventBus"
                                :price="!isEmpty(prices) ? prices[product.sku] : {}"
        ></dentaid-product-teaser>
    </div>
</template>
